import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Titulo } from '../models/titulo';

const BUSCAR_API = environment.apiUrl + '/buscar';
const DESCARGAR_API = environment.apiUrl + '/descargar';

@Injectable({
  providedIn: 'root'
})
export class BuscarService {

  constructor(protected http: HttpClient) { }

  buscarTramite(tipoDni: string, dni: string): Observable<Titulo[]> {
    let datos: any = {};
    datos.tipo_documento = tipoDni;
    datos.numero_documento = dni;
    return this.http.post<Titulo[]>(BUSCAR_API, datos);
  }

  descargarArchivo(id_proceso: number): Observable<any> {
    let datos: any = {};
    datos.id_proceso = id_proceso
    return this.http.post<any>(DESCARGAR_API, datos);
  }
}
